// Page d'espace « Contestations » : file des demandes d'explication et contestations des candidats (F-029).
import { useState } from "react";
import { useGet } from "@core/hooks";
import { useOrg } from "@core/org";
import { ButtonLink, Card, Empty, ErrorBox, Loading, PageHeader, Stat, Tabs } from "@core/ui";
import { ContestationItem, type Contestation } from "./DecisionTab";

export function ContestationsPage() {
  const org = useOrg();
  const [filter, setFilter] = useState<"ouverte" | "repondue" | "toutes">("ouverte");
  const url = org.api(`/contestations${filter === "toutes" ? "" : `?status=${filter}`}`);
  const q = useGet<{ items: Contestation[] }>(url);
  const all = useGet<{ items: Contestation[] }>(org.api("/contestations"));
  const items = q.data?.items ?? [];
  const openCount = (all.data?.items ?? []).filter((c) => c.status === "ouverte").length;
  return (
    <div className="page">
      <PageHeader
        eyebrow="Location"
        title="Contestations et demandes d’explication"
        intro="Les candidats peuvent demander des explications sur une décision ou la contester. Répondez sur des faits ; si une erreur est reconnue, modifiez la décision depuis la candidature."
      />
      <div className="stats">
        <Stat label="En attente de réponse" value={openCount} />
        <Stat label="Total des demandes" value={(all.data?.items ?? []).length} />
      </div>
      <Tabs
        value={filter}
        onChange={setFilter}
        items={[
          { value: "ouverte", label: "À traiter" },
          { value: "repondue", label: "Répondues" },
          { value: "toutes", label: "Toutes" },
        ]}
      />
      {q.isLoading ? <Loading /> : null}
      <ErrorBox error={q.error} />
      {!q.isLoading && !items.length ? (
        <Empty title={filter === "ouverte" ? "Aucune demande en attente" : "Aucune demande"}>Les demandes des candidats apparaîtront ici, avec la candidature concernée.</Empty>
      ) : null}
      <div className="stack">
        {items.map((c) => (
          <Card key={c.id}>
            <ContestationItem c={c} orgId={org.orgId} canRespond={org.can("decide")} prefixes={[org.api("/contestations"), org.api(`/applications/${c.application_id}`), org.api("/decision-summary")]} showContext />
            <div className="form-actions">
              <ButtonLink to={org.to(`candidatures/${c.application_id}`)} variant="discret" small>
                Ouvrir la candidature
              </ButtonLink>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
